(function () {
  function upgrade() {
    var tables = document.querySelectorAll('.shopify-policy__body table, .rte table, .page-content table');

    [].forEach.call(tables, function (table) {
      if (table.classList.contains('hb-table')) return;

      var heads = [].map.call(table.querySelectorAll('thead th'), function (heading) {
        return heading.textContent.trim();
      });

      if (heads.length) {
        [].forEach.call(table.querySelectorAll('tbody tr'), function (row) {
          [].forEach.call(row.children, function (cell, index) {
            if (heads[index] && !cell.getAttribute('data-label')) {
              cell.setAttribute('data-label', heads[index]);
            }
          });
        });
      }

      [].forEach.call(table.querySelectorAll('th, td'), function (cell) {
        cell.style.border = '';
        cell.style.padding = '';
        cell.style.background = '';
      });

      table.style.border = '';
      table.style.background = '';

      var wrapper = table.parentElement;
      if (wrapper && /overflow/i.test(wrapper.getAttribute('style') || '')) {
        wrapper.style.overflowX = 'visible';
      }

      table.classList.add('hb-table');
    });
  }

  if (document.readyState !== 'loading') {
    upgrade();
  } else {
    document.addEventListener('DOMContentLoaded', upgrade);
  }
})();
